const release = ""
const apiClientBaseURL = "/api/"

// TODO:
const originURL = "https://sportident-tibi-2024.code.testversion.online"
const cryptchaSiteId = "6628f06a0938460001505119"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}
/**
 *
 * @param {number} price
 * @param {number} quantity
 * @param {boolean|string} localeString
 * @returns {number|string}
 */
function formatPrice(price, quantity = 1, localeString = true) {
    if (typeof price != "number" || isNaN(price)) return localeString ? "" : 0

    const newPrice = (Math.round(price * 100) / 100) * quantity

    let _p

    _p = newPrice.toLocaleString(typeof localeString == "string" ? localeString : "de", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })

    return _p + " " + "€"
}

module.exports = {
    release,
    apiClientBaseURL,
    frontendBase: "https://bkdf.code.testversion.online/",
    tibiUrl: "https://bkdf-tibiadmin.code.testversion.online/",
    bkdfApiUrl: "https://bkdf.code.testversion.online/api/",
    originURL,
    cryptchaSiteId,
    formatPrice,
}
